module.exports = __webpack_public_path__ + "img/16d002-10.9ad0a105.png";